const prodProperties = {
  profile: "prod",
  apiBaseUrl: "https://massbusinesszone.com",
  msil: {
    // CRITICAL SECURITY FIX: clientId is OK to expose (OAuth client IDs are public)
    clientId: "42gc3dtl45anvj24c9msbri04k",
    redirectUrl: "https://massbusinesszone.com/AdminHome/dashboard",
    federatedLoginUrl: "https://massbusinesszone.com/api/auth/federated-login",
    exchangeUrl: "https://massbusinesszone.com/api/auth/exchange-token",
    sessionUrl: "https://massbusinesszone.com/api/auth/session",
    revenueUrl: "https://massbusinesszone.com/api/v1/admin/revenue",
    // CRITICAL SECURITY FIX: Removed apiKey - now handled securely by backend
    // Backend endpoint: /api/auth/logout-federation
    // apiKey is stored in backend application.properties and never exposed to frontend
  },
};

export default prodProperties;

